angular.module('acme.view.application.importExport.jobExecution.controllers.importExportDeleteJobModalController', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.directive.dataGrid',
  'acme.common.service.permissions',
  'acme.view.application.importExport.jobExecution.directives.importExportJobExecutionFileUpload',
  'acme.view.application.importExport.jobExecution.directives.importExportJobExecutionErrorGrid',
])
.controller('ImportExportDeleteJobModalController', ImportExportDeleteJobModalController);

/**
 * Controller responsible for showing the user the Job they're about to delete
 * @class ImportExportDeleteJobModalController
 * @constructor
 * @return {ImportExportDeleteJobModalController} - Class instance
 */
function ImportExportDeleteJobModalController(
  $uibModalInstance,
  JOB_TYPE,
  ImportJobsApiService,
  ImportExportsApiService,
  job)
{
  Object.assign(this, {
    $uibModalInstance: $uibModalInstance,
    JOB_TYPE: JOB_TYPE,
    ImportJobsApiService: ImportJobsApiService,
    ImportExportsApiService: ImportExportsApiService,
    job: job
  });

  // TODO: update ui-router to 0.3.0 to avoid calling this manually
  this.$onInit();
}

ImportExportDeleteJobModalController.prototype.$onInit = function() {
  this.vm = this._getVm(this);
};

ImportExportDeleteJobModalController.prototype._getVm = function (initialData) {
  var _data = initialData || {},
    errorMessage = _data.errorMessage || '',
    job = _data.job || '';

  return {
    errorMessage: errorMessage,
    job: job
  };
};

ImportExportDeleteJobModalController.prototype.cancel = function () {
  this.$uibModalInstance.close();
};

ImportExportDeleteJobModalController.prototype.remove = function () {
  var self = this,
    removePromise;

  removePromise = this.ImportJobsApiService.remove(this.job.id);

  removePromise
    .then(function () {
      self.$uibModalInstance.close(true);
    }, function (response) {
      var errorMessage = 'Unable to delete Job, please try again, or try again later.';

      if (response.status === 409) {
        errorMessage = 'Unable to delete a Job that has Job Executions.';
      }

      self.vm.errorMessage = errorMessage;
    });
};

ImportExportDeleteJobModalController.$inject = [
  '$uibModalInstance',
  'JOB_TYPE',
  'ImportJobsApiService',
  'ImportExportsApiService',
  'job'
];
